import i18n from '@/locales/i18n'

const locale = i18n.global.locale

const useInteraction = (event = null, params = {}) => {
  if (window.fresco && window.fresco.interaction) {
    window.fresco.interaction()
  }
  if (event) {
    // eslint-disable-next-line
    gtag('event', event, {
      'debug_mode': import.meta.env.DEV,
      'current_language': locale.value,
      ...params
    })
  }
}

export default useInteraction
